export default __webpack_public_path__ + "static/media/logo-mtlogin-gray-icon.0dad0e8b.svg";